import React, { FormEvent, useState } from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import InputFieldText from '../../components/input/floating-label/input-field/InputFieldText';
import Button, { ButtonType } from '../../components/button/Button';
import { StateModel } from '../../redux/store';
import { connect } from 'react-redux';
import GridCellWrapper from '../../components/grid-cell-wrapper/GridCellWrapper';

import { forget } from '../../redux/actions/benutzer';

export interface ForgottenPasswordProps {
  forget: (nameOrMail: string) => void;
}

const ForgottenPassword = (
  props: ForgottenPasswordProps & RouteComponentProps
) => {
  const [name, setName] = useState('');

  const onSubmit = (e?: FormEvent) => {
    props.forget(name);
    e?.preventDefault();
  };

  return (
    <div className='forgottenPasswordStart'>
      <div className='wrapper-forgottenPassword'>
        <GridCellWrapper
          classes='forgottenPassword'
          label='hier ist das label'
          saveUserAnsicht={() => {
            null;
          }}
        >
          <img
            className='login-pic'
            src={process.env.PUBLIC_URL + '/login-pic.png'}
          />
          <div className='forgottenPassword-form'>
            <h3>Brauchen Sie Hilfe mit Ihrem Passwort?</h3>
            <div id={'label'}>
              Bitte geben Sie Ihren Username oder die registrierte
              E-Mail-Adresse an. Sie bekommen dann ein neues Passwort per Email
              zugesandt.
            </div>
            <form id={'forgottenPassword'} onSubmit={e => onSubmit(e)}>
              <InputFieldText
                onChangeHandler={setName}
                value={name}
                name={'username'}
                label='Benutzername oder E-Mail-Adresse'
                classes='forgottenPassword-input'
                required={true}
              />
              <div className={'forgottenPassword-btn'}>
                <Button type={ButtonType.submit}>Passwort anfordern</Button>
                <Link to='/Login'>
                  <Button
                    type={ButtonType.button}
                    onClickHandler={() => props.history.push('/login')}
                  >
                    zurück zur Anmeldung
                  </Button>
                </Link>
              </div>
            </form>
          </div>
        </GridCellWrapper>
      </div>
    </div>
  );
};

const mapStateToProps = (state: StateModel) => ({});

export default connect(mapStateToProps, { forget })(
  withRouter(ForgottenPassword)
);
